import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function MesAchats() {
  const [achats, setAchats] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;
  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const fetchAchats = async () => {
      try {
        const token = getToken();
        const response = await fetch(`${API_BASE}/etudiant/cours/get_mes_achats.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.success) setAchats(data.achats);
      } catch (error) {
        toast.error('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    fetchAchats();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div><p className="mt-4 text-gray-600">Chargement...</p></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">📚 Mes cours achetés</h1>

      {achats.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center"><div className="text-5xl mb-4">📚</div><p className="text-gray-500">Vous n'avez encore acheté aucun cours</p><button onClick={() => navigate('/etudiant/cours/marche')} className="mt-3 text-green-600 hover:underline">Découvrir des cours</button></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {achats.map(achat => (
            <div key={achat.id_achat} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition border">
              <div className="p-4 border-b bg-gradient-to-r from-green-50 to-emerald-50"><h3 className="font-bold text-lg text-gray-800">{achat.titre}</h3><p className="text-sm text-gray-500 mt-1">Par {achat.prenom} {achat.nom}</p></div>
              <div className="p-4"><p className="text-sm text-gray-600 mb-3 line-clamp-2">{achat.description || 'Aucune description'}</p><div className="flex justify-between items-center"><div className="text-sm text-gray-500"><span>Acheté le {new Date(achat.date_achat).toLocaleDateString()}</span><span className="ml-2 text-green-600 font-semibold">{achat.montant.toLocaleString()} F</span></div><button onClick={() => navigate(`/etudiant/cours/${achat.id_cours}/lire`)} className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition">📖 Lire le cours</button></div></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}